module.exports = __webpack_public_path__ + "assets/social-listview-icon.b8ad4a7e.svg";